import { render, staticRenderFns } from "./winners-modal.component.vue?vue&type=template&id=631f81da&scoped=true"
import script from "./winners-modal.component.vue?vue&type=script&lang=js"
export * from "./winners-modal.component.vue?vue&type=script&lang=js"
import style0 from "./winners-modal.component.vue?vue&type=style&index=0&id=631f81da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f81da",
  null
  
)

export default component.exports